import { render, staticRenderFns } from "./TeachRoomQues.vue?vue&type=template&id=68d44c21&"
import script from "./TeachRoomQues.vue?vue&type=script&lang=js&"
export * from "./TeachRoomQues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports